import React from 'react'
import PropTypes from 'prop-types'
import { thousandSeparator } from 'utils/NumeralFormat'
import { Link } from 'react-router'

import Moment from 'moment'

import Styles from './index.scss'

const Item = props => {
  const { row, invoiceStatus, tab, countries } = props

  // -- Filtered country -- //
  const filteredCountry = countries.filter(country => country.id === row.order.country)[0]

  // -- Function for check status label -- //
  const statusChecker = (status, invoiceStatusParam) => {
    if (status === invoiceStatusParam.pending.status) {
      return invoiceStatusParam.pending.label
    } else if (status === invoiceStatusParam.paid.status) {
      return invoiceStatusParam.paid.label
    } else if (status === invoiceStatusParam.failed.status) {
      return invoiceStatusParam.failed.label
    }
    return 'No status available'
  }

  // -- Function for set color depends on status -- //
  const statusColorChecker = (status, invoiceStatusParam) => {
    if (status === invoiceStatusParam.pending.status) {
      return '#f6e405'
    } else if (status === invoiceStatusParam.paid.status) {
      return '#96e83c'
    } else if (status === invoiceStatusParam.failed.status) {
      return '#ff8f9d'
    }
    return 'transparent'
  }

  const isPaymentMethod = payment => {
    if (payment === 'credit_card') {
      return 'Credit Card'
    } else if (payment === 'id_credit_transfer_bca') {
      return 'Virtual Account BCA'
    } else if (payment === 'id_credit_transfer_bni') {
      return 'Virtual Account BNI'
    }
    return 'Manual Transfer'
  }

  return (
    <tr>
      {/* Condition for panding tab */
      tab === 1 && (
        <td>
          &nbsp;
          {/* Checkbox */}
          <input type="checkbox" />
        </td>
      )
      /* ---- */
      }
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Invoice Date */}
        <span>
          {row.createdAt ? Moment(`${row.createdAt}`).format('MMMM, DD YYYY') : '-'}
        </span>
      </td>
      {/* Condition for all payment tab */
      tab === 0 && (
        <td style={{ fontSize: '12px' }}>
          &nbsp;
          {/* Status */}
          <div
            className={Styles.status}
            style={{ backgroundColor: statusColorChecker(row.status, invoiceStatus) }}
          >
            <span>{statusChecker(row.status, invoiceStatus)}</span>
          </div>
        </td>
      )
      /* ---- */
      }
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Profile ID */}
        <span>{row.profile && row.profile.profileId ? row.profile.profileId : '-'}</span>
      </td>
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Country Code */}
        <span>
          {row.order && row.order.country && filteredCountry ? filteredCountry.code : '-'}
        </span>
      </td>
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Project Name */}
        <Link to={`/projects/${row.order.id}`}>
          <span>{row.order && row.order.name ? row.order.name : '-'}</span>
        </Link>
      </td>
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Invoice Number */}
        <span>{row.invoiceNumber ? row.invoiceNumber : '-'}</span>
      </td>
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Payment Method */}
        <span>{isPaymentMethod(row.paymentMethod)}</span>
      </td>
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Due Date */}
        {row.dueDate ? Moment(`${row.dueDate}`).format('MMMM, DD YYYY') : '-'}
      </td>
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Paid Date */}
        {row.deadlineDate ? Moment(`${row.deadlineDate}`).format('MMMM, DD YYYY') : '-'}
      </td>
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Invoice Type */}
        {row.invoiceType ? row.invoiceType : '-'}
      </td>
      <td style={{ fontSize: '12px' }}>
        &nbsp;
        {/* Invoice Amount */}
        {row.quotation && row.total
          ? `${row.quotation.currency} ${thousandSeparator(row.total)}`
          : '-'}
      </td>
      {/* Condition for pending tab */
      tab === 1 && (
        <td>
          &nbsp;
          {/* Action */}
          <div style={{ display: 'flex' }}>
            <button className={Styles.approve}>Approve</button>
            <button className={Styles.reject}>Reject</button>
          </div>
        </td>
      )
      /* ---- */
      }
    </tr>
  )
}

Item.defaultProps = {
  row: {
    order: {
      name: '',
    },
    status: 0,
    profile: {
      profileId: '',
    },
    invoiceNumber: '',
    createdAt: '',
    dueDate: '',
    deadlineDate: '',
    invoiceType: '',
    total: 0,
  },
  skip: 0,
  indexKey: 0,
}

Item.propTypes = {
  tab: PropTypes.number.isRequired,
  row: PropTypes.shape({
    order: PropTypes.shape({
      name: PropTypes.string,
    }),
    status: PropTypes.number,
    profile: PropTypes.shape({
      profileId: PropTypes.string,
    }),
    invoiceNumber: PropTypes.string,
    createdAt: PropTypes.string,
    dueDate: PropTypes.string,
    deadlineDate: PropTypes.string,
    invoiceType: PropTypes.string,
    total: PropTypes.number,
  }),
  invoiceStatus: PropTypes.shape({
    pending: PropTypes.shape({
      status: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    paid: PropTypes.shape({
      status: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    failed: PropTypes.shape({
      status: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Item
